import { Box, Flex } from 'components/box';
import resourceUrl from '../../../../util/make-url';
import { Heading, Text } from 'components/typography';
import { css } from '@emotion/react';

const Empty = () => (
  <Flex
    alignItems="center"
    py={[2, null, 4]}
    mb={[1, 2]}
    flexDirection={['column', null, 'row-reverse']}
    css={theme => css`
      gap: ${theme.space[3]}px;
      @media ${theme.mediaQueries.desktopUp} {
        gap: 0;
      }
    `}
  >
    <Flex
      flexDirection="column"
      css={theme => css`
        gap: ${theme.space[2]}px;
      `}
    >
      <Heading
        fontWeight={800}
        fontSize={['8rem', '14.75rem']}
        lineHeight={[0.8]}
        textAlign={[null, 'center', 'unset']}
        css={theme => css`
          @media ${theme.mediaQueries.desktopUp} {
            text-indent: -20px;
          }
        `}
      >
        OOF!
      </Heading>

      <Text
        fontFamily="header"
        fontWeight={800}
        fontSize={[5, 7]}
        textAlign={[null, 'center', 'unset']}
      >
        THIS IS BOUND TO HAPPEN{' '}
        <span
          css={theme => css`
            color: ${theme.colors.success};
          `}
        >
          SOMETIMES.
        </span>
      </Text>

      <Text
        fontFamily="header"
        fontWeight={700}
        fontSize={[3, 4]}
        lineHeight={1.3}
        textAlign={[null, 'center', 'unset']}
      >
        It looks like we don&apos;t currently have any BIG DEALS that match this
        category. Don&apos;t panic though - we have new deals every 24 hours, so
        be sure to check back soon. If not today, there&apos;s always tomorrow!
        Or the next day, or the next!
      </Text>
    </Flex>

    <Box>
      <img
        src={resourceUrl('odo/product-bundle.png', {
          width: 700,
          isAssetUrl: true,
        })}
        alt="Product Bundle"
        css={theme => css`
          width: 700px;
          max-width: calc(100vw + 30px);
          margin-left: -15px;
          margin-right: -15px;
          @media ${theme.mediaQueries.desktopUp} {
            margin-left: -40px;
            margin-right: -60px;
          }
        `}
      />
    </Box>
  </Flex>
);

export default Empty;
